var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8668 4.80005H8.53343L10.935 7.20165L8.51317 9.89232L5.7105 7.08965C5.50197 6.88112 5.1649 6.88112 4.95637 7.08965L2.2897 9.75632C2.08117 9.96485 2.08117 10.3019 2.2897 10.5104C2.49823 10.719 2.8353 10.719 3.04383 10.5104L5.33343 8.22085L8.15637 11.0438C8.2561 11.144 8.3921 11.2 8.53343 11.2C8.68597 11.2 8.82943 11.135 8.9297 11.0235L11.6897 7.95685L13.8668 10.1334V4.80005Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilization);
export default __webpack_public_path__ + "static/media/utilization.b740a4de.svg";
export { ForwardRef as ReactComponent };